import type { AnswerOption } from '@/modules/simulado/domain/entities/answer.entity';

export const ANSWER_DIFFICULTIES = ['EASY', 'MEDIUM', 'HARD'] as const;

export type AnswerDifficulty = (typeof ANSWER_DIFFICULTIES)[number];

/**
 * Uma questão do gabarito, pronta para o diagnóstico: o número, a letra certa,
 * se ela vale e a dificuldade. Mesma forma do `AnswerKeyEntry` do
 * `enamed-feedback-lp` — lá vinha do Remote Config, aqui sai da própria questão
 * da Aristo (`toAnswerKey`, em `question.entity.ts`).
 */
export interface AnswerKeyEntry {
  number: number;
  /** `null` quando a questão não tem resposta certa utilizável. */
  answer: AnswerOption | null;
  isOpenToAppeal?: boolean;
  /** Anulada: sai do universo do diagnóstico. */
  isExcluded: boolean;
  difficulty?: AnswerDifficulty;
}
